import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Orders() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('current');

  const currentOrders = [
    {
      id: '#ORD-2024-001',
      storeName: 'بقالة الأمانة',
      status: 'preparing',
      statusText: 'جاري التحضير',
      items: 3,
      total: 42.50,
      estimatedTime: '15-20 دقيقة',
      image: 'https://public.readdy.ai/ai/img_res/256afbc102d637d88102882ae90d3319.jpg'
    },
    {
      id: '#ORD-2024-002',
      storeName: 'مخبز الذهبي',
      status: 'on_way',
      statusText: 'في الطريق',
      items: 2,
      total: 18.00,
      estimatedTime: '5-10 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20and%20bakery%20items%2C%20artisan%20bakery%20products%2C%20clean%20background%2C%20appetizing%20presentation%2C%20golden%20brown%20bread&width=60&height=60&seq=order-bakery&orientation=squarish'
    }
  ];

  const pastOrders = [
    {
      id: '#ORD-2024-003',
      storeName: 'بقالة الأمانة',
      status: 'delivered',
      statusText: 'تم التوصيل',
      items: 5,
      total: 67.25,
      date: '15 ديسمبر 2024',
      image: 'https://readdy.ai/api/search-image?query=Delivered%20grocery%20order%2C%20fresh%20vegetables%20and%20fruits%2C%20realistic%20food%20photography%2C%20clean%20background%2C%20successful%20delivery&width=60&height=60&seq=order-delivered&orientation=squarish'
    },
    {
      id: '#ORD-2024-004',
      storeName: 'صيدلية النور',
      status: 'delivered',
      statusText: 'تم التوصيل',
      items: 2,
      total: 45.00,
      date: '14 ديسمبر 2024',
      image: 'https://readdy.ai/api/search-image?query=Pharmacy%20products%20and%20medications%2C%20healthcare%20items%2C%20clean%20white%20background%2C%20professional%20medical%20photography&width=60&height=60&seq=order-pharmacy&orientation=squarish'
    },
    {
      id: '#ORD-2024-005',
      storeName: 'مطعم البيت الشامي',
      status: 'delivered',
      statusText: 'تم التوصيل',
      items: 4,
      total: 89.50,
      date: '13 ديسمبر 2024',
      image: 'https://readdy.ai/api/search-image?query=Middle%20Eastern%20food%20delivery%2C%20traditional%20Arabic%20cuisine%2C%20appetizing%20restaurant%20meal%2C%20clean%20background&width=60&height=60&seq=order-restaurant&orientation=squarish'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'preparing':
        return 'bg-orange-100 text-orange-600';
      case 'on_way':
        return 'bg-blue-100 text-blue-600';
      case 'delivered':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  const handleTrackOrder = (orderId: string) => {
    navigate(`/track-order?orderId=${orderId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* الهيدر */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-4 pt-12">
          <button onClick={() => navigate(-1)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <h1 className="text-lg font-bold">طلباتي</h1>
          <div className="w-10"></div>
        </div>
      </div>

      {/* التبويبات */}
      <div className="bg-white border-b border-gray-200">
        <div className="flex">
          <button
            onClick={() => setActiveTab('current')}
            className={`flex-1 py-3 text-center font-medium ${
              activeTab === 'current'
                ? 'text-green-600 border-b-2 border-green-600'
                : 'text-gray-500'
            }`}
          >
            الطلبات الحالية
          </button>
          <button
            onClick={() => setActiveTab('past')}
            className={`flex-1 py-3 text-center font-medium ${
              activeTab === 'past'
                ? 'text-green-600 border-b-2 border-green-600'
                : 'text-gray-500'
            }`}
          >
            الطلبات السابقة
          </button>
        </div>
      </div>

      <div className="px-4 mt-4">
        {activeTab === 'current' ? (
          currentOrders.length > 0 ? (
            <div className="space-y-4">
              {currentOrders.map((order) => (
                <div key={order.id} className="bg-white rounded-lg shadow-sm p-4">
                  <div className="flex items-start space-x-3 space-x-reverse">
                    <img
                      src={order.image}
                      alt={order.storeName}
                      className="w-15 h-15 rounded-lg object-cover"
                    />
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <h3 className="font-medium text-gray-800">{order.storeName}</h3>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(order.status)}`}>
                          {order.statusText}
                        </span>
                      </div>
                      <p className="text-sm text-gray-500 mb-1">رقم الطلب: {order.id}</p>
                      <p className="text-sm text-gray-500 mb-2">{order.items} عناصر • {order.total} ر.س</p>
                      <p className="text-sm text-green-600 font-medium mb-3">
                        الوصول المتوقع: {order.estimatedTime}
                      </p>
                      <div className="flex space-x-2 space-x-reverse">
                        <button
                          onClick={() => handleTrackOrder(order.id)}
                          className="flex-1 bg-green-500 text-white py-2 rounded-lg text-sm font-medium"
                        >
                          تتبع الطلب
                        </button>
                        <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-600">
                          اتصال
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-96">
              <i className="ri-file-list-line text-6xl text-gray-300 mb-4"></i>
              <h2 className="text-xl font-bold text-gray-600 mb-2">لا توجد طلبات حالية</h2>
              <p className="text-gray-500 text-center mb-6">ابدأ بطلب منتجاتك المفضلة</p>
              <button
                onClick={() => navigate('/home')}
                className="bg-green-500 text-white px-6 py-3 rounded-lg font-medium"
              >
                ابدأ التسوق
              </button>
            </div>
          )
        ) : (
          <div className="space-y-4">
            {pastOrders.map((order) => (
              <div key={order.id} className="bg-white rounded-lg shadow-sm p-4">
                <div className="flex items-start space-x-3 space-x-reverse">
                  <img
                    src={order.image}
                    alt={order.storeName}
                    className="w-15 h-15 rounded-lg object-cover"
                  />
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-medium text-gray-800">{order.storeName}</h3>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(order.status)}`}>
                        {order.statusText}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mb-1">رقم الطلب: {order.id}</p>
                    <p className="text-sm text-gray-500 mb-2">{order.items} عناصر • {order.total} ر.س</p>
                    <p className="text-sm text-gray-500 mb-3">{order.date}</p>
                    <div className="flex space-x-2 space-x-reverse">
                      <button className="flex-1 bg-green-500 text-white py-2 rounded-lg text-sm font-medium">
                        إعادة الطلب
                      </button>
                      <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-600">
                        تقييم
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button 
            onClick={() => navigate('/home')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button 
            onClick={() => navigate('/cart')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-shopping-cart-line text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button className="flex flex-col items-center justify-center text-green-500">
            <i className="ri-file-list-fill text-xl mb-1"></i>
            <span className="text-xs">طلباتي</span>
          </button>
        </div>
      </div>
    </div>
  );
}